import React from 'react';
import PatientFormTemplate from '../components/PatientFormTemplate';

export default function PatientADHDScalesAdulthoodForm() {
    return (
        <PatientFormTemplate formTitle="Your Symptoms in Adulthood" />
    );
}